/**
 * Created by Administrador on 05/11/2018.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('modifyValidity', {
                parent: 'app',
                url: '/modifyValidity',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/modifyValidity/findPnr.html',
                        controller: 'findModifyValidityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['modifyValidity']);
                            }]
                        }
                    }
                }
            })
            .state('modifyValidityEdit', {
                parent: 'app',
                url: '/modifyValidity/:codePnr/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/modifyValidity/modifyValidity.html',
                        controller: 'editModifyValidityCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['modifyValidity']);
                    }],
                    documentTypes: ['documentTypeService', function(documentTypeService) {
                        return documentTypeService.getDocumentTypes();
                    }],
                    pnr: ['transferPassengerService', '$stateParams', function(transferPassengerService, $stateParams){
                        return transferPassengerService.getPNR($stateParams.codePnr);
                    }],
                    operation: ['operationService', function(operationService){
                        return operationService.getOperationByCode('RMVP');
                    }]
                }
            })
    }
})();
